/**
 * Stable CSS class names for E2E — Product dashboard page.
 */
export const PD = {
    page: 'product-dashboard-page',
    layout: 'product-dashboard-page__layout',
    headerRow: 'product-dashboard-page__header-row',
    title: 'product-dashboard-page__title',

    dateFilterSection: 'product-dashboard-page__date-filter-section',
    dateFormControl: 'product-dashboard-page-input__form-control--date',
    dateSelect: 'product-dashboard-page-input--select-date',
    dateSelectItem: 'product-dashboard-page-input--select-date-item',

    groupSummaryLeft: 'product-dashboard-page__group-summary-left',
    groupSummaryRight: 'product-dashboard-page__group-summary-right',
    summaryRowName: 'product-dashboard-page__summary-row--name',
    summaryRowTotalQty: 'product-dashboard-page__summary-row--total-qty',
    summaryRowReservedQty: 'product-dashboard-page__summary-row--reserved-qty',
    summarySpinner: 'product-dashboard-page__summary-spinner',

    chartsRow: 'product-dashboard-page__charts-row',
    chartWarehouse: 'product-dashboard-page__chart--warehouse',
    chartWarehouseType: 'product-dashboard-page__chart--warehouse-type',

    warehouseSelectSection: 'product-dashboard-page__warehouse-select-section',
    warehouseFormControl: 'product-dashboard-page-input__form-control--warehouse',
    warehouseSelect: 'product-dashboard-page-input--select-warehouse',
    warehouseSelectItem: 'product-dashboard-page-input--select-warehouse-item',

    warehouseSummary: 'product-dashboard-page__warehouse-summary',
} as const;

export const pdCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

